import { Amplify } from '@aws-amplify/core';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { awsConfig } from 'aws-exports';

import { useUsers } from 'hooks/useUsers';
import { useAuthSelector, useAuthStore } from 'stores';

const AmplifyProvider = ({ children }) => {
  const { getSession, handleLogout } = useAuthSelector();
  const { getUserInfo, userMfa } = useUsers();

  useEffect(() => {
    Amplify.configure(awsConfig);
    sessionInit();
    userMfa().then(({ isMfaEnabled }) => {
      // console.log('isMfaEnabled', isMfaEnabled);
      !isMfaEnabled && handleLogout();
    });

    getUserInfo().then(user => {
      if (!user) return;
      useAuthStore.setState({ user });
    });
  }, []);

  const sessionInit = useCallback(async () => {
    await getSession();
  }, [getSession]);

  return <>{children}</>;
};

AmplifyProvider.propTypes = {
  children: PropTypes.node,
};

export { AmplifyProvider };
